import type { DefaultTheme } from 'styled-components';
import { FuuzeColors } from './colors.js';

declare module 'styled-components' {
  export interface DefaultTheme extends IFuuzeTheme {}
}

export interface IFuuzeTheme {
  colors: {
    dark: {
      dark100: string;
      dark200: string;
      dark300: string;
      dark400: string;
      dark500: string;
      dark600: string;
      dark700: string;
      dark800: string;
      dark900: string;
    };
    orange: {
      orange20: string;
      orange30: string;
      orange40: string;
      orange50: string;
      orange60: string;
      orange70: string;
      orange80: string;
      orange90: string;
      orange100: string;
    };
    background: string;
    yellow: string;
    green: string;
    red: string;
    white: string;
    text: string;
  };
  typography: {
    h1: {
      fontSize: number;
    };
    h1Bold: {
      fontSize: number;
    };
    h2: {
      fontSize: number;
    };
    h2Bold: {
      fontSize: number;
    };
    body: {
      fontSize: number;
    };
    bodyBold: {
      fontSize: number;
    };
    body2: {
      fontSize: number;
    };
    body2Bold: {
      fontSize: number;
    };
  };
  variables: {
    navigationBarHeight: string;
    navigationBarWidth: string;
  };
}

export const FuuzeTheme: DefaultTheme = {
  colors: FuuzeColors,
  typography: {
    h1: {
      fontSize: 27,
    },
    h1Bold: {
      fontSize: 27,
    },
    h2: {
      fontSize: 22,
    },
    h2Bold: {
      fontSize: 22,
    },
    body: {
      fontSize: 16,
    },
    bodyBold: {
      fontSize: 16,
    },
    body2: {
      fontSize: 14,
    },
    body2Bold: {
      fontSize: 14,
    },
  },
  variables: {
    navigationBarHeight: 'var(--navigation-bar-height)',
    navigationBarWidth: 'var(--navigation-bar-width)',
  },
};
